import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", () => {
//     navigator.serviceWorker
//       .register("/sw.js")
//       .then((registration) => {
//         console.log("Service worker registered:", registration.scope);
//       })
//       .catch((error) => {
//         console.error("Service worker registration failed:", error);
//       });
//   });
// }

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    if (registrations.length > 0) {
      console.log("Mendeteksi Service Worker aktif, mencoba menghapus...");
      for (let registration of registrations) {
        registration.unregister().then((boolean) => {
          if (boolean) {
            console.log("Service Worker berhasil di-unregister.");
            // Opsional: Paksa reload halaman sekali saja jika SW baru dihapus
            // agar user langsung dapat versi tanpa cache
            // window.location.reload();
          }
        });
      }
    } else {
      console.log("Tidak ada Service Worker yang aktif.");
    }
  });

  // Hapus juga cache storage yang mungkin tersisa
  if ("caches" in window) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  }
}
